import { useCallback, useState } from 'react';

import { noticeDismissKey } from './noticeKinds';

const STORAGE_KEY = 'predico.dismissedNotices';

const read = () => {
  try {
    return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY)) || []);
  } catch {
    return new Set();
  }
};

/**
 * Notices this browser dismissed, keyed on (id, updated_at) so an edit shows
 * a notice again. Shared by the dashboard panel and the Notices page.
 *
 * @returns {{isDismissed: Function, dismiss: Function, restore: Function}}
 */
export default function useDismissedNotices() {
  const [dismissed, setDismissed] = useState(read);

  const update = useCallback((notice, add) => {
    setDismissed((current) => {
      const next = new Set(current);
      if (add) next.add(noticeDismissKey(notice));
      else next.delete(noticeDismissKey(notice));
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify([...next]));
      } catch {
        // Private mode or full storage: remembered for this visit only.
      }
      return next;
    });
  }, []);

  return {
    isDismissed: useCallback((notice) => dismissed.has(noticeDismissKey(notice)), [dismissed]),
    dismiss: useCallback((notice) => update(notice, true), [update]),
    restore: useCallback((notice) => update(notice, false), [update]),
  };
}
